import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { stripeSlice } from '../modules/stripe/state/stripe.slice';
import { configSlice } from './slices/config.slice';
import { themeSlice } from './slices/theme.slice';
import { userSlice } from './slices/user.slice';

const rootReducer = combineReducers({
  [configSlice.name]: configSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [themeSlice.name]: themeSlice.reducer,
  [stripeSlice.name]: stripeSlice.reducer,
});

let store: AppStore;

export const makeStore = () => {
  // ! IMPORTANT: Do not use redux-persist as it will cause unwanted white screen flashes when the PersistGate is loading
  // If you're looking to persist client only data then use `_client/storage/clientLocalStorage.ts` instead
  const newStore = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
  });
  store = newStore;
  return newStore;
};

export { store };

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
